import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback(this.state.error);
      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <div className="card max-w-md w-full text-center">
            <div className="text-4xl mb-4">⚠️</div>
            <h1 className="text-xl font-bold text-gray-900 mb-2">Váratlan hiba történt</h1>
            <p className="text-gray-600 mb-6 text-sm">Kérjük frissítse az oldalt. Ha a hiba ismétlődik, értesítse a szervezőket.</p>
            <button className="btn-primary w-full" onClick={() => window.location.reload()}>
              Oldal újratöltése
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
